import '.cc{position:relative;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.hh{min-height:200px;}.ssr-plugin'
import '.l{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.cg{align-items:flex-start;}.ssr-plugin'
import '.a3{padding:2rem;}.ssr-plugin'
import '.ci{background:var(--palette-white);}.ssr-plugin'
import '.c{overflow:hidden;}.ssr-plugin'
import '.b7{position:absolute;}.ssr-plugin'
import '.iw{top:50%;}.ssr-plugin'
import '.ix{right:1rem;}.ssr-plugin'
import '.iy{transform:translateY(-50%);}.ssr-plugin'
import '.iz{width:120px;}.ssr-plugin'
import '.j0{height:120px;}.ssr-plugin'
import '.j1{z-index:0;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.ia{z-index:1;}.ssr-plugin'
import '.n{gap:0.5rem;}.ssr-plugin'
import '.j2{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="cc h hh l m a1 cg a3 ci c"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="b7 iw ix iy iz j0 j1 l aa a1"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="cc ia l m cg n j2"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
